"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var window_scroll_1 = __importDefault(require("@react-hook/window-scroll"));
function JumpToTop(_a) {
  var children = _a.children;
  var y = window_scroll_1.default();
  function goToTop() {
    if (typeof window === 'undefined') {
      console.warn('JumpToTop: no window available');
      return;
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  return children(y, goToTop);
}
exports.JumpToTop = JumpToTop;